export default __webpack_public_path__ + "static/media/down-arrow.74bc9414.svg";